import { render } from "./OSCE.vue?vue&type=template&id=c9fac6da&scoped=true"
import script from "./OSCE.vue?vue&type=script&lang=js"
export * from "./OSCE.vue?vue&type=script&lang=js"

import "./OSCE.vue?vue&type=style&index=0&id=c9fac6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fac6da"]])

export default __exports__